import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

@Component({
  template: '',
})
export class LogoutComponent {
  constructor(private _as: AuthService, private _router: Router) {
    this._as.logout({ forceLogout: true });
  }
}
